export enum OrgOnboardingStep {
  ACCOUNT_DETAILS = 1,
}
